module.exports = __webpack_public_path__ + "static/media/bac-plus.a419c639.svg";